// extracted by mini-css-extract-plugin
export default {"ScrollComponent":"ScrollComponent_d2xtb","ScrollComponent__animate":"ScrollComponent__animate_kME1U","show":"show_dSkCL","hideUp":"hideUp_oFm1y","hideDown":"hideDown_BHkvC"};